import React, { useRef, useState, useEffect, useContext } from 'react';
import useOnScreen from '../../../hooks/useOnScreen';
import { Navigate } from 'react-router-dom';
import { FilterContext } from '../../../context/FilterContext';

function Category({ data, index, delay }) {
  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const isVisible = useOnScreen(ref);
  const [redir, setRedir] = useState('');
  const fi = useContext(FilterContext);

  useEffect(() => {
    if (isVisible && !show) {
      setShow(true);
    }
  }, [isVisible]);
  return (
    <div
      onClick={(e) => {
        if (data.nombre !== 'Ver Todas') {
          fi.dispatch({
            type: 'set_aplicaciones_filter',
            payload: { aplicaciones: [data.id] },
          });
        }

        setRedir('/productos');
      }}
      ref={ref}
      className={`basis-full  transition-all duration-500 ease-in p-1 ${delay} md:text-left box-border md:basis-1/5 text-left  ${
        show ? 'translate-y-0 opacity-100' : 'translate-y-1/4 opacity-0'
      }`}
    >
      {redir && <Navigate to={redir} replace />}
      <div className="w-full overflow-hidden">
        <img
          className="transition-transform duration-500 hover:scale-110"
          src={require(`../../../assets/images/categories/${data.imagen}`)}
        />
      </div>
      <span className="py-4 block font-light text-lg">{data.nombre}</span>
    </div>
  );
}
export default Category;
